<template>
    <div v-if="value1 || value2">
        <div class="progress">
            <div
                class="progress-bar progress-bar-first"
                :style="{ width: getPercentage1 }"
            ></div>
            <div
                class="progress-bar progress-bar-second"
                :style="{ width: getPercentage2 }"
            ></div>
        </div>
        <div class="flex">
            <div class="grow">
                {{ description1 }}: {{ this.value1 }} ({{ getPercentage1 }})
            </div>
            <div class="grow text-right">
                {{ description2 }}: {{ this.value2 }} ({{ getPercentage2 }})
            </div>
        </div>
    </div>

    <div v-else class="text-gray">No data available.</div>
</template>

<script>
export default {
    props: ['value1', 'value2', 'description1', 'description2'],
    computed: {
        getPercentage1() {
            if (this.value1 === 0 && this.value2 === 0) {
                return 50 + '%';
            }
            return (
                ((this.value1 * 100) / (this.value1 + this.value2)).toFixed(1) +
                '%'
            );
        },
        getPercentage2() {
            if (this.value1 === 0 && this.value2 === 0) {
                return 50 + '%';
            }
            return (
                ((this.value2 * 100) / (this.value1 + this.value2)).toFixed(1) +
                '%'
            );
        },
    },
};
</script>

<style scoped>
.flex {
    display: flex;
}

.grow {
    flex-grow: 1;
}

.text-right {
    text-align: right;
}

.progress {
    width: 100%;
    display: flex;
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 5px;
}

.progress-bar {
    height: 15px;
}

.progress-bar-first {
    background: #09b3af;
}

.progress-bar-second {
    background: #f0ad4e;
}
</style>



// WEBPACK FOOTER //
// ChartProgress.vue?13ee6e2c